import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  accentIcon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  accentIcon,
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="flex items-center gap-3">
        <span className="w-1 h-6 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950 flex items-center gap-2">
            {accentIcon && <i className={`${accentIcon} text-primary-500`}></i>}
            {title}
          </h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}